export const projectSlideList = [
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-2nd/section4_slide_img1.png',
    intro: 'PROJECT 1 : 레거시',
    title: '로컬 기반 클라우드 인프라 구축',
    boldPc: '온프레미스 환경에 최적화된 인프라 설계 전략과 기술',
    boldM: '온프레미스 환경에 최적화된 인프라 설계 전략과 기술',
    desc: '가상 머신 기반 가상 네트워크, 가상 스토리지, \n컨테이너화, 보안까지 체계적으로 배울 수 있어요',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-2nd/section4_slide_img2.png',
    intro: 'PROJECT 2 : AWS 클라우드',
    title: 'AWS 기반 클라우드 인프라 구축',
    boldPc: 'AWS 클라우드 환경에서 금융 환경을 위한\n고가용성 설계 전략과 핵심 기술',
    boldM: 'AWS 클라우드 환경에서 금융 환경을 위한\n고가용성 설계 전략과 핵심 기술',
    desc: 'VPC/Subnet, ELB, Route53, CloudWatch, RDS,\nS3, 쿠버네티스를 통한 배포 환경 구축, 자동화를 위한\nTerraform 등을 체계적으로 배울 수 있어요',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-2nd/section4_slide_img3.png',
    intro: 'PROJECT 3 : 하이브리드',
    title: '하이브리드 기반 클라우드 인프라 구축',
    boldPc:
      '실무 환경에서 많이 사용되는 온프레미스 및 퍼블릭\n클라우드 간의 하이브리드 인프라 구축,백엔드 서비스를\n연계한 통합 운영 방안과 실전 기술을 배울 수 있어요 ',
    boldM:
      '실무 환경에서 많이 사용되는 온프레미스 및\n퍼블릭 클라우드 간의 하이브리드 인프라 구축,\n백엔드 서비스를 연계한 통합 운영 방안과\n실전 기술을 배울 수 있어요',
  },
]

export const curriculumDetailList = [
  {
    id: 0,
    step: '1-2주차',
    title: 'Java와 데이터베이스 \n기초/심화',
    contents: [
      {
        contentsIntro: '웹 아키텍쳐 학습',
      },
      {
        contentsIntro: 'Java 기초 및 심화',
        contentsInner: [
          'Java 기초 : Object, Class, Exception',
          'Java 기초 : Generic, Collection, Framework, Stream, Lambda, I/O, Thread',
        ],
      },
      {
        contentsIntro: '데이터베이스의 이해',
        contentsInner: [
          'MySQL 기초 및 SQL(DQL, Join, Subquery)',
          'MySQL 심화 및 SQL(DML, DDL, DCL), 데이터 모델링',
        ],
      },
    ],
    skillText: '사용 스킬',
    skillUrlPc: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section6_img1_pc.png',
    skillUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section6_img1_m.png',
  },
  {
    id: 1,
    step: '3주차',
    title: '웹 클라이언트 및 서버 개발',
    contents: [
      {
        contentsIntro: '웹 클라이언트 개발',
        contentsInner: ['HTML5, CSS3 기초', 'JavaScript 기초 및 심화'],
      },
      {
        contentsIntro: '웹 서버 어플리케이션 개발',
        contentsInner: ['Servlet, JSP 기초 및 심화'],
      },
    ],
    skillText: '사용 스킬',
    skillUrlPc: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section6_img2_pc.png',
    skillUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section6_img2_m.png',
  },
  {
    id: 2,
    step: '4-5주차',
    title: 'Spring Boot 실무 개발',
    contents: [
      {
        contentsIntro: 'Spring Boot 기초 및 심화 학습',
        contentsInner: [
          'Spring Boot 기초',
          'Spring Web MVC',
          'Spring Boot RESTful API 및 \nSpring Data JPA',
          'AOP, Redis',
          'Thymeleaf, Spring Security, Token',
          'Spring Boot 어플리케이션 테스트',
        ],
      },
      {
        contentsIntro: '미니 프로젝트',
        contentsInner: ['커뮤니티 게시판 만들기'],
      },
    ],
    skillText: '사용 스킬',
    skillUrlPc: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section6_img3_pc.png',
    skillUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section6_img3_m.png',
  },
  {
    id: 3,
    step: '6-8주차',
    title: '인프라 설계 및 구축',
    contents: [
      {
        contentsIntro: '네트워크 및 리눅스 시스템 기초',
        contentsInner: [
          '네트워크 기초 \n(OSI 7 Layer/프로토콜의 개념 이해)',
          'Linux OS 이해 및 가상 서버 구축',
          '리눅스 명령어 기본 실습',
          'Shell 프로그래밍 기본',
        ],
      },
      {
        contentsIntro: 'Docker 가상화 및 컨테이너 관리',
        contentsInner: [
          'Docker 가상화 및 컨테이너 관리',
          'Docker 가상화 개념 및 기본 실습',
          'Docker 이미지 및 컨테이너 관리',
          'Docker 네트워크 및 볼륨 관리',
          'Dockerfile 및 Docker Registry 관리',
          'N-tier 어플리케이션 구성',
        ],
      },
    ],
    skillText: '사용 스킬',
    skillUrlPc: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section6_img4_pc.png',
    skillUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section6_img4_m.png',
  },
  {
    id: 4,
    step: '9주차',
    title: '프로젝트 #1',
    contents: [
      {
        contentsIntro: 'VM 기반 가상 인프라 구축 프로젝트',
        contentsInner: ['VM 기반 가상 인프라 구축 및 관리 방법 실습'],
      },
    ],
  },
  {
    id: 5,
    step: '9-15주차',
    title: '클라우드 인프라 실무',
    contents: [
      {
        contentsIntro: '클라우드 기본 아키텍처 설계',
        contentsInner: [
          'Cloud Computing Architecture 이해',
          'VPC, Subnet, Route Table의 개념 및 실습',
        ],
      },
      {
        contentsIntro: 'AWS 주요 서비스 활용',
        contentsInner: [
          'EC2, EBS, ELB, Route53 구성',
          'AutoScaling 및 CloudWatch 활용',
          'RDS, S3를 활용한 어플리케이션 배포 테스트',
        ],
      },
      {
        contentsIntro: 'CI/CD와 자동화 배포',
        contentsInner: [
          'CI/CD 개념 이해 및 Github Actions 이해 및 실습',
          'Workflow, Job 설정 및 AWS 연계 배포',
        ],
      },
      {
        contentsIntro: 'Kubernetes 실무 이해와 구현',
        contentsInner: [
          'Kubernetes 아키텍처 이해 및 클러스터 구축',
          'Pod, Deployment, Service, Network 구성',
          'Volume 설정, 보안, Helm Chart 활용',
        ],
      },
      {
        contentsIntro: 'Infrastructure as Code (IaC)',
        contentsInner: ['Terraform 개념 및 코드 작성', 'Kubernetes와 Terraform 통합 테스트'],
      },
      {
        contentsIntro: 'GitOps와 배포 자동화',
        contentsInner: ['GitOps 개념 이해', 'ArgoCD 활용 및 배포 관리'],
      },
      {
        contentsIntro: '성능 테스트와 최적화',
        contentsInner: ['Monitoring 및 트래픽 성능 테스트', 'Openshift 아키텍처 이해 및 보안'],
      },
      {
        contentsIntro: '고급 클라우드 기술과 통합',
        contentsInner: [
          'Service Mesh 및 Serverless 활용',
          'CloudFormation 실습',
          '클라우드 통합 테스트 및 최종 점검',
        ],
      },
    ],
    skillText: '사용 스킬',
    skillUrlPc: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section6_img6_pc.png',
    skillUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section6_img6_m.png',
  },
  {
    id: 6,
    step: '16주차',
    title: '프로젝트 #2',
    contents: [
      {
        contentsIntro: 'AWS기반 인프라 구축',
        contentsInner: [
          'AWS를 활용한 클라우드 인프라 구축',
          'EC2, S3, RDS 등을 다루며 클라우드 아키텍처 설계 및 구축',
          '클라우드 구축 기초부터 실무에 적용 가능한 고급 스킬 학습',
        ],
      },
    ],
  },
  {
    id: 7,
    step: '17-22주차',
    title: '최종 프로젝트 #3',
    contents: [
      {
        contentsIntro: 'AWS 기반 BackEnd/DevOps 프로젝트 \n(하이브리드 클라우드 구축)',
        contentsInner: [
          'AWS와 온프레미스 인프라를 결합하여 \n하이브리드 클라우드를 구축',
          '백엔드 시스템 설계 및 운영',
          'DevOps 도구를 활용해 CI/CD 파이프라인과 자동화된 운영 체계 구현',
          '클라우드와 온프레미스 환경을 통합한 \n실무 역량 완성',
        ],
      },
      {
        contentsIntro: '최종 프로젝트 발표 기반 수료식',
      },
    ],
  },
]

export const supportStartSlideList = [
  {
    count: '01',
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-2nd/section2_slide_img1.png',
    title: 'AWS or CKA\n자격증 지원',
    desc: 'AWS 혹은 CKA 응시 후 합격자에 한하여\n1회의 자격증 비용을 지원해요',
  },
  {
    count: '02',
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-2nd/section2_slide_img2.png',
    title: 'AWS 클라우드\n리소스 지원',
    desc: '150만원 상당의 AWS 리소스를\n지원해요',
  },
  {
    count: '03',
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-2nd/section2_slide_img3.png',
    title: '백엔드 프리러닝,\n스프링부트 VOD 제공',
    desc: '수료 전 기초를 다지고 싶으신 분들을\n위해 백엔드 프리러닝 강의를 제공해요',
  },
  {
    count: '04',
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-2nd/section2_slide_img4.png',
    title: 'AWS 관련 공식 도서 외\n구글 클라우드 도서 제공',
    desc: '멀티 클라우드를 위한 학습 콘텐츠를\n수료생에게 지원해요',
  },
  {
    count: '05',
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-2nd/section2_slide_img5.png',
    title: '기업 채용 연계 또는\n채용 설명회 진행',
    desc: '수료생에 한하여 멋쟁이사자처럼 단독 기업 채용 연계와 채용 설명회를 진행해요',
  },
  {
    count: '06',
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-2nd/section2_slide_img6.png',
    title: '기술사 유튜버\n(기술노트 with 알렉) 특강',
    desc: 'AWS클라우드의 스페셜리스트,\n‘기술노트 with알렉’의 특강을 제공해요',
  },
  {
    count: '07',
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-2nd/section2_slide_img7.png',
    title: 'AWS\nCheatsheet 제공',
    desc: 'AWS 마스터를 위한 컨닝페이퍼, AWS Cheatsheet를 한정 지급해요',
  },
]

export const firstCompanyList = [
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-2nd/section3_slide_img1.png',
    title: '쿠팡 채용공고',
    bold: '대용량 데이터 및 트래픽 환경',
    desc2: '에서의 백엔드 엔지니어링 경험이 있는 분',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-2nd/section3_slide_img2.png',
    title: '카카오 채용공고',
    desc1: 'HTTP(Eestful) API 디자인 및 ',
    bold: '대용량 트래픽',
    desc2: '개발 경험이 있는 분',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-2nd/section3_slide_img3.png',
    title: '토스 채용공고',
    bold: '대용량의 실시간 트래픽',
    desc2: '을 처리하는 서비스를 운영하신 경험',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-2nd/section3_slide_img4.png',
    title: '컬리 채용공고',
    bold: '대용량 트래픽',
    desc2: ' 고려해서 개발을 해보신 분',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-2nd/section3_slide_img5.png',
    title: '배달의 민족 채용공고',
    bold: '대규모 트래픽',
    desc2: ' 처리 경험이 있으신 분',
  },
]

export const secondCompanyList = [
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-2nd/section3_slide_img6.png',
    title: '리디 채용공고',
    bold: '대용량 트래픽',
    desc2: '을 위한 설계 및 구현에 대한 이해를 갖추신 분',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-2nd/section3_slide_img7.png',
    title: '넥슨 채용공고',
    bold: 'AWS 등 클라우드 환경에서의 개발 경험',
    desc2: '이 있으신 분',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-2nd/section3_slide_img8.png',
    title: '라인 채용공고',
    bold: '대용량 트래픽  ',
    desc2: '서비스 개발 및 설계, 운영 경험이 있으신 분',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-2nd/section3_slide_img9.png',
    title: '야놀자 채용공고',
    bold: '대규모 트래픽',
    desc2: '이나 대용량 데이터 처리를 위한 시스템 설계 및 개발 경험',
  },
]

export const supportSlideList = [
  {
    title: 'AWS SAA 자격증 비용 전액 지원',
    desc: '교육 수료자 가운데, AWS SAA \n합격자를 대상으로 1회의 자격증 응시 \n비용을 지원해요. \n(수료 후 2개월까지 응시 비용 지원)',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/support_slide_img1_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/support_slide_img1_m.png',
  },
  {
    title: 'AWS 클라우드 리소스 지원',
    desc: '팀 프로젝트 진행 시, AWS 클라우드 \n리소스를 지원해요.',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/support_slide_img2_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/support_slide_img2_m.png',
  },
  {
    title: '백엔드 사전학습, 스프링 부트 \n실무 프로젝트 VOD 제공',
    desc: '수강 전 기초를 다지고 싶은 분들에게 \n프리러닝 강의를 제공해요.',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/support_slide_img3_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/support_slide_img3_m.png',
  },
  {
    title: '관련 도서 지원',
    desc: '교육 수료자를 대상으로 AWS 심화 \n내용을 익히고 자격증 공부에 \n활용할 수 있도록 AWS 공인 서적 \n최신판을 지원해요.',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/support_slide_img4_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/support_slide_img4_m.png',
  },
]

export const supportDetailList = [
  {
    id: 0,
    step: '하나',
    title: '이력서 특강',
    contents: [
      {
        contentsId: '1',
        contentsInner: [
          '이력서 구성 전략, 합격하는 이력서 비교 분석, 지원 직무와 일치하는 키워드 기입법 등 이력서 작성의 모든 것을 알려드려요. 커리어 코치의 이력서 1:1 피드백으로 합격하는 이력서를 완성할 수 있어요.',
        ],
      },
    ],
  },
  {
    id: 1,
    step: '둘',
    title: '포트폴리오 공개 피드백',
    contents: [
      {
        contentsId: '2',
        contentsInner: [
          '포트폴리오 구성 전략, 프로젝트 스토리텔링 기법 등 포트폴리오를 어떻게 효과적으로 디자인하는지 알려드려요. \n커리어 코치의 포트폴리오 1:1 피드백으로 취업에 강한 포트폴리오를 함께 만들어요.',
        ],
      },
    ],
  },
  {
    id: 2,
    step: '셋',
    title: '모의 면접 특강',
    contents: [
      {
        contentsId: '3',
        contentsInner: [
          '면접 클리닉을 통해 지원 직무에 기반한 면접 질문을 예상해보고 기술 면접과 인성 면접을 대비해요. \n마지막에는 팀별 모의 면접으로 취업의 마지막 관문까지 함께 준비해요.',
        ],
      },
    ],
  },
  {
    id: 3,
    step: '넷',
    title: '수료 후 취업지원',
    contents: [
      {
        contentsId: '4',
        contentsInner: [
          '교육 과정 수료 후 6개월간 지속적인 구직활동을 관리해드려요. 커리어 코치와의 상담 및 개인 맞춤형 취업 지원으로 포기하지 않고 취업할 수 있도록 도와드려요.',
        ],
      },
    ],
  },
]

export const reviewSlideList = [
  {
    title: '새로운 기술을 도입해보는 \n과정을 배울 수 있었습니다.',
    desc: '이 교육을 통해서 클라우드 관련 교육도 \n받고 비용이 소모되는 클라우드 프로젝트도 \n할 수 있어서 좋았습니다. 그리고 함께했던 \n수강생분들의 수준이 높아서 동기부여가 \n되었고, 새로운 기술을 도입해보는 과정이 \n뜻 깊었던 것 같습니다.',
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/review_img1.png',
  },
  {
    title: '수강하길 정말 잘했습니다!',
    desc: '과정 시작 전에는 온라인 진행 방식에 대한 \n걱정이 많았었는데, 막상 시작하니 통학시간 \n을 절약함으로써 그 시간들을 개인 공부, \n체력관리에 쓸 수 있는 점이 엄청 큰 \n장점이었고 만족감이 컸습니다.',
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/review_img3.png',
  },
  {
    title: '인프라 지식이 크게 \n상승했습니다.',
    desc: '수업이 굉장히 좋아 클라우드와 같은 인프라 \n지식이 크게 상승하였습니다.',
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/review_img2.png',
  },
  {
    title: '어려웠던 AWS를 \n배울 수 있었습니다.',
    desc: '어려웠던 AWS의 다양한 기능들과 추가적인 \n다른 기능들까지 직접 프로젝트를 통해 배우고 적용해 볼 수 있어서 좋았습니다.',
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/review_img4.png',
  },
]

export const benefitSlideList = [
  {
    title: '교육비 전액 무료',
    desc: '내일배움카드로 약 1,452만원 상당의 \n교육을 무료로 들을 수 있어요',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/benefit_slide_img1_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/benefit_slide_img1_m.png',
  },
  {
    title: '훈련장려금 지급',
    desc: '매월 최대 31만원 상당의 \n훈련장려금이 지급돼요',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/benefit_slide_img2_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/benefit_slide_img2_m.png',
  },
  {
    title: '교육 장비 지원',
    desc: '교육 시작 전, 교육 장비가 필요한 인원\n에 한하여 무료로 장비를 대여해 드려요',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/benefit_slide_img3_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/benefit_slide_img3_m.png',
  },
  {
    title: '오프라인 프로젝트 공간 지원',
    desc: '사전 신청자에 한하여 프로젝트를 진행\n할 수 있는 오프라인 공간을 지원해요',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/benefit_slide_img4_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/benefit_slide_img4_m.png',
  },
]

export const CldBenefitList = [
  {
    title: '교육비 전액 무료',
    desc: ' 내일배움카드로 약 1,700만원 상당의\n 교육을 무료로 들을 수 있어요',
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-2nd/benefit_img1.png',
  },
  {
    title: '훈련장려금 지급',
    desc: '매월 최대 31만원 상당의\n 훈련장려금이 지급돼요',
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-2nd/benefit_img2.png',
  },
  {
    title: '교육 장비 지원',
    desc: '교육 시작 후, 교육 장비가 필요한 인원에 한하여 무료로 장비를 대여해 드려요',
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-2nd/benefit_img3.png',
  },
  {
    title: '오프라인 프로젝트 공간 지원',
    desc: '사전 신청자에 한하여 프로젝트를 진행할 수 있는 오프라인 공간을 지원해요',
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-2nd/benefit_img4.png',
  },
]

export const CldApplyScheduleList = [
  {
    title: '모집기간',
    content: '2025년 2월 14일(금) 오전 11시 ~ \n2025년 3월 23일(일) 오후 11시',
  },
  {
    title: '서류 합격자 \n발표일',
    contents: [
      '1차 합격자 발표일 : 2월 21일(금)',
      '2차 합격자 발표일 : 2월 28일(금)',
      '3차 합격자 발표일 : 3월 7일(금)',
      '4차 합격자 발표일 : 3월 14일(금)',
      '5차 합격자 발표일 : 3월 24일(월)',
    ],
  },
  {
    title: '최종 결과 \n발표',
    content: '서류 합격자 안내 메일 참고 부탁드립니다.',
  },
]

export const AfterCldApplyScheduleList = [
  {
    title: '모집기간',
    content: '2025년 2월 14일(금) 오전 11시 ~ \n2025년 3월 25일(화) 오후 6시',
  },
  {
    title: '서류 합격자 \n발표일',
    contents: [
      '1차 합격자 발표일 : 2월 21일(금)',
      '2차 합격자 발표일 : 2월 28일(금)',
      '3차 합격자 발표일 : 3월 7일(금)',
      '4차 합격자 발표일 : 3월 14일(금)',
      '5차 합격자 발표일 : 3월 25일(화)',
    ],
  },
  {
    title: '최종 결과 \n발표',
    content: '서류 합격자 안내 메일 참고 부탁드립니다.',
  },
]

export const CldEduScheduleList = [
  {
    title: '교육기간',
    content: '25년 3월 27일(목) - 25년 8월 22(금)',
  },
  {
    title: '교육시간',
    content: '800시간 / 평일 9시 - 18시 \n(점심시간 12시 - 13시 제외)',
  },
  {
    title: '학습형태',
    content: '실시간 온라인 교육',
  },
  {
    title: '참고사항',
    contents: [
      '국민내일배움카드로 K-Digital Training 과정에  참여할 수 있는 분만 \n수강 가능합니다.',
      '매달 출석률에 따라 훈련장려금이 차등 지급됩니다.',
    ],
  },
]

export const bootCampFaqTabList = [
  { label: '전체', value: 'all' },
  {
    label: '지원',
    value: 'apply',
  },
  {
    label: '선발',
    value: 'nebeka',
  },
  {
    label: '취업',
    value: 'employment',
  },
  {
    label: '교육운영',
    value: 'edu',
  },
  {
    label: '특전혜택',
    value: 'benefit',
  },
  {
    label: '기타',
    value: 'etc',
  },
]

interface IBootCampFaqList {
  [key: string]: {
    question: string
    answer?: string
    secondAnswer?: string
    externalUrl1?: string
    urlName1?: string
    externalUrl2?: string
    urlName2?: string
    answerList?: string[]
  }[]
}

export const bootCampFaqList: IBootCampFaqList = {
  apply: [
    {
      question: '[지원] 지원 자격이 있나요?',
      answer:
        '국민내일배움카드를 보유하고 있거나 발급 가능하다면 누구든지 지원하실 수 있습니다. 발급 가능 여부는 고용노동부 1350 또는 거주지 관할 고용센터에서 직접 확인해주셔야 합니다.\n국민내일배움카드를 발급받고 교육 기간 동안 주 5일, 매일 약 8시간의 교육 과정에 온전히 참여하실 수 있다면 원칙상 수강할 수 있으나, 직장과 병행해야 해서 정해진 시간에 출석할 수 없고 하루 8시간의 학습 시간을 채울 수 없는 경우 선발에서 제외됨을 알려드립니다.',
    },
    {
      question: '[지원] 국민내일배움카드가 없어도 지원할 수 있나요?',
      answer:
        '지원은 가능합니다. 다만 최종 합격 발표 전까지는 모바일 앱 카드 혹은 실물 카드를 소지하고 있으셔야 합니다. 모바일 앱 카드의 경우, 신청 당일에 즉시 발급이 가능하지만 오프라인 카드 발급은 최종 수령까지 일주일 이상 소요될 수 있기에 고용노동부 1350을 통해 카드 발급 자격 확인 및 발급 신청을 빠르게 하시는 것을 추천드립니다.',
    },
    {
      question: '[지원] 국민내일배움카드는 반드시 오프라인에서만 발급 받을 수 있나요?',
      answer:
        '국민내일배움카드는 고용24 홈페이지를 통해 신청 가능하며 오프라인과 온라인 모두 발급 받으실 수 있습니다.',
      externalUrl1: '/nebeca',
      urlName1: '국민내일배움카드 신청 방법 확인하기 (링크)',
      externalUrl2: '/nebeca/issued',
      urlName2: '국민내일배움카드 모바일 앱 카드 발급 방법 확인하기 (링크)',
    },
    {
      question: '[지원] 고용24 신청은 언제 할 수 있나요?',
      answer:
        '최종 합격자로 선발된 후, 합격하신 분들께 별도로 안내해 드릴 예정입니다. 안내를 받으신 후 고용24에서 신청해주시면 됩니다.',
    },
    {
      question: '[지원] 비전공자도 지원 가능한가요?',
      answer:
        '네. 지원 가능합니다. 전공과 무관하게 클라우드 엔지니어가 되려는 강한 의지와 계획이 있으시면 됩니다. 다만, 합격 후 5개월 동안 정말 몰입해서 학습을 이어가셔야 합니다. 꾸준한 의지와 학습 습관으로 목표하시는 변화를 만들어내시기 바랍니다.',
    },
    {
      question: '[지원] 지원서 제출 후 수정 가능한가요?',
      answer: '지원서 수정은 불가능합니다. 항목을 미리 검토하신 후 제출하시기 바랍니다.',
    },
    {
      question: '[지원] 다른 부트캠프와 중복 지원 가능한가요?',
      answer:
        '멋쟁이사자처럼이 운영하는 다른 부트캠프와 중복 지원은 불가합니다. 다른 훈련기관이 운영하는 과정에 중복지원하는 것은 가능합니다. 희망하는 부트캠프에 한해 하나만 지원 가능하므로 신중하게 고민하고 선택해주세요.',
    },
  ],
  nebeka: [
    {
      question: '[선발] 선발 절차는 어떻게 되나요?',
      answer:
        '국민내일배움카드 신청 → 1차 지원서(서류) 제출 → 최종합격자 발표 → 고용24 수강신청 순으로 진행됩니다. 국민내일배움카드 발급에 일주일 이상 소요되므로 발급 신청을 먼저 해주시기 바랍니다.',
    },
    {
      question: '[선발] 합격 확인은 어떻게 하나요?',
      answer:
        '각 단계별로 합격하신 분들께는 E-mail과 SMS로 안내드릴 예정입니다. 발표 일정은 상세페이지를 참고해주세요.\n*발표 일정은 상황에 따라 일부 변경될 수 있습니다.',
    },
  ],
  employment: [
    {
      question: '[취업] 취업 지원 프로그램이 제공되나요?',
      answer:
        '클라우드 엔지니어의 최신 채용 트렌드를 반영한 전문적인 이력서 특강 및 피드백을 통한 취업 지원을 받으실 수 있습니다.',
    },
  ],
  edu: [
    {
      question: '[교육 운영] 교육은 어디서 진행되나요?',
      answer:
        '교육은 오프라인이 아닌, 온라인 라이브로 진행되며 국내에서, 거주 지역에 무관하게 학습할 수 있습니다.',
    },
    {
      question: '[교육 운영] 온라인 수업 출결은 어떻게 진행되나요?',
      answer:
        '두 가지 방법으로 출결이 진행됩니다.\n 1. 고용24 앱 설치 후 QR코드 인증(개인 진행)\n 2. 줌 모니터링을 통한 매 시간 출결 체크(운영진 진행, 줌 화면에 얼굴이 정확히 확인되어야 출석 인정)\n추가로, 수업 참여 중 장소 이동은 불가합니다. 장소 이동 시 출결에 불이익이 발생하니 이점 유의 부탁드립니다.',
    },
    {
      question: '[교육 운영] 수업에 빠질 경우 강의를 다시 볼 수 있나요?',
      answer:
        '본 교육 과정은 학습을 포함한 모든 내용을 영상으로 추가 제공하지 않습니다. 따라서 다음 수업 내용을 잘 따라가기 위해서는 반드시 출석해주셔야 합니다.',
    },
    {
      question: '[교육 운영] 교육 기간 중 쉬는 날은 없나요?',
      answer:
        '교육 기간 내 주말, 공휴일에는 교육을 진행하지 않습니다. 수업 외 일정에 관해서는 오리엔테이션에서 자세하게 안내드릴 예정입니다. 교육기간 5개월동안 온전하게 몰입하시는 것을 권유드립니다.',
    },
    {
      question: '[교육 운영] 해외에서도 참여할 수 있나요?',
      answer:
        'KDT 프로그램의 특성상, 해외에서 수강하는 것은 불가능합니다. 교육 참여 중에 해외로 이동하는 것 역시 불가능합니다.',
    },
  ],
  benefit: [
    {
      question: '[특전 혜택] 합격생에게 제공되는 혜택이 있나요?',
      answerList: [
        '· 멋쟁이사자처럼 수료생 커뮤니티 활동 기회를 제공합니다.',
        '· 수료 후 정기적으로 진행되는 행사참여 및 네트워킹 기회를 제공합니다. (KDT 수료생에 한함)',
        '· 기초 학습 및 성장을 위한 유료 강의를 제공합니다.',
        '· 이력서 특강 등 개인 맞춤 성장 프로그램을 제공합니다.',
      ],
    },
  ],
  etc: [
    {
      question: '[기타] 훈련장려금을 받을 수 있나요?',
      answer:
        '네. 훈련 장려금은 월 최대 316,000원까지 받으실 수 있으며, 매달 출석률에 따라 차등 지급됩니다. \n국민취업제도에 참여 중인 분들의 경우, 훈련 장려금 외에 추가 훈련 수당을 받으실 수 있으며 1유형에 해당하시는 분들은 500,000원의 훈련수당까지 더해 월 최대 816,000원을 지급받으실 수 있고 2유형에 해당하시는 분들은 284,000원의 훈련수당까지 더해 월 최대 600,000원을 지급받으실 수 있습니다. \n다만, 개인의 상황에 따라 참여 가능한 유형이 다르고 지급받을 수 있는 금액이 다를 수 있기에 반드시 고용24를 통해 확인 및 신청 바랍니다.',
    },
    {
      question: '[기타] 훈련 자비 부담액은 얼마인가요?',
      answer: '본 교육과정은 내일배움카드를 소지하신 분들을 대상으로 전액 무료로 진행됩니다.',
    },
  ],
}
